import { apiClient } from '../utils/api-client'
import type { WeeklyCheckIn, WeeklyCheckInPayload } from '../types/weekly-check-in'

interface CheckInResponse {
  data: { id: string; type: string; attributes: WeeklyCheckIn }
}

interface CheckInsResponse {
  data: Array<{ id: string; type: string; attributes: WeeklyCheckIn }>
}

class WeeklyCheckInsService {
  async list(from?: string, to?: string): Promise<WeeklyCheckIn[]> {
    const query = from && to ? `?from=${from}&to=${to}` : ''
    const response = await apiClient.get(`/api/weekly_check_ins${query}`, { requireAuth: true })
    const json: CheckInsResponse = await response.json()
    return json.data.map((d) => ({ ...d.attributes, id: d.id }))
  }

  /** Creating over a week that already has an entry edits it — see the service. */
  async create(payload: WeeklyCheckInPayload): Promise<WeeklyCheckIn> {
    const response = await apiClient.post('/api/weekly_check_ins', {
      data: { attributes: payload },
    }, { requireAuth: true })
    const json: CheckInResponse = await response.json()
    return { ...json.data.attributes, id: json.data.id }
  }

  async update(id: string, payload: Partial<WeeklyCheckInPayload>): Promise<WeeklyCheckIn> {
    const response = await apiClient.patch(`/api/weekly_check_ins/${id}`, {
      data: { attributes: payload },
    }, { requireAuth: true })
    const json: CheckInResponse = await response.json()
    return { ...json.data.attributes, id: json.data.id }
  }

  async destroy(id: string): Promise<void> {
    await apiClient.delete(`/api/weekly_check_ins/${id}`, { requireAuth: true })
  }
}

export const weeklyCheckInsService = new WeeklyCheckInsService()
